// extracted by mini-css-extract-plugin
module.exports = {"bagWrapper":"ShoppingBagIcon_bagWrapper__d6e7V","bag":"ShoppingBagIcon_bag__xZs_4"};